<template>
  <span @click='filter'
        :data-cat="item.id"
        :class='{"active": active}'>
    <span v-if='language === "en" && item.acf.english_name.length > 0'>{{item.acf.english_name}}</span>
    <span v-else>{{item.name}}</span>
  </span>
</template>

<script>
import globalgrid from '../globalGrid'
export default {
  name: 'dsFilterItem',
  props: ['item', 'language'],
  data() {
    return {
      active: false
    }
  },
  mounted() {
    // console.dir(globalgrid.grid)
    setTimeout(() => {
      // console.dir(globalgrid.grid)
      globalgrid.grid.on('arrangeComplete', e => {
        if (globalgrid.grid.options.filter !== '.category-' + this.item.id) {
          this.active = false
        }
      })
    }, 1000)
  },
  methods: {
    filter() {
      console.log('clicked')
      console.dir(globalgrid.grid)
      if (this.active === false) {
        this.active = true
        globalgrid.grid.arrange({
          filter: '.category-' + this.item.id
        })
      } else {
        this.active = false
        globalgrid.grid.arrange({
          filter: ''
        })
      }
    }
  }
}
</script>

<style lang='scss' scoped>
@import '../styles/helpers/_mixins.scss';
@import '../styles/responsive/_manager.scss';
@import '../styles/_variables.scss';
@import '../styles/_space.scss';
@import '../styles/_color.scss';

.active {
  // font-family: "UniversLTCYR-75Black", 'helvetica', sans-serif;
  text-decoration: underline;
  color: black !important;
}
</style>



// WEBPACK FOOTER //
// dsFilterItem.vue?58320c60